import type { BetterAuthClientPlugin } from 'better-auth/client';

import { setNativeSessionToken } from './capacitor-session';

function extractSessionToken(context: {
  data?: { token?: string };
  response: Response;
}): string | null {
  const headerToken = context.response.headers.get('set-auth-token');
  if (headerToken) {
    return headerToken;
  }
  const bodyToken = context.data?.token;
  if (typeof bodyToken === 'string' && bodyToken.length > 0) {
    return bodyToken;
  }
  return null;
}

/** Stores bearer tokens returned by the API (Capacitor cannot use cross-subdomain cookies). */
export function capacitorAuthPlugin(): BetterAuthClientPlugin {
  return {
    id: 'capacitor',
    fetchPlugins: [
      {
        id: 'capacitor-auth',
        name: 'CapacitorAuth',
        hooks: {
          async onSuccess(context) {
            const token = extractSessionToken(context);
            if (token) {
              await setNativeSessionToken(token);
            }
          },
        },
      },
    ],
  };
}
